<template>
  <el-dialog
    class="ts-modal ts-modal--sga no-padding"
    :before-close="closeModal"
    :visible.sync="this.$props.ShowModal"
    width="760px"
    title="Role Info"
  >
    <div class="ts-modal--sga-header">
      <div class="ts-modal--sga-header_profile">
        <div class="match_percent" v-if="this.$props.Info">
          <el-progress
            type="circle"
            :width="70"
            :stroke-width="4"
            color="#14223C"
            :percentage="Math.round(this.$props.Info.matchedPercentage)"
          ></el-progress>
        </div>
        <div v-if="this.$props.Info" style="padding-left:20px;padding-top:15px;">
          <h6>{{ this.$props.Info.roleTitle }}</h6>
          <span>{{ this.$props.Info.companyName }}</span>
        </div>
      </div>
      <div>
        <div style="padding-bottom: 20px">
          <el-dropdown trigger="click" style="float: right">
            <i
              class="fa fa-ellipsis-h"
              aria-hidden="true"
              style="font-size: 20px"
            ></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="cancelJobMatch"
                ><i class="el-icon-circle-close"></i>Cancel Job
                Match</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div style="float:right;">
          <span>Status: 
            <span v-if="this.$props.Info.employerStatus === 1"> Reached Out</span>
            <span v-if="this.$props.Info.employerStatus === 2"> Connected</span>
            <span v-if="this.$props.Info.employerStatus === 3"> Interview Process</span>
          </span>
        </div>
      </div>
    </div>

    <div class="ts-modal--sga-header">
      <div class="ts-modal--sga-header_profile">
        <div>
          <span class="header">Role Details</span>
        </div>
      </div>
    </div>
    <div class="ts-modal--tabs">
      <el-tabs v-model="activeTab" type="card">
        <el-tab-pane name="upskilling" v-if="this.$props.Info && this.$props.Info.fullSGA && this.$props.Info.fullSGA.sgaUpSkills">
					<span slot="label"><i class="el-icon-star-on"></i> Upskilling</span>
          <span class="h6">Upskilling Required</span>
					<div class="sga-split">
						<div class="sga-items" v-if="this.$props.Info.fullSGA.sgaUpSkills.knowledgeRegularlyUsed && !user.isPlaceholderRole">
							<div class="sga-items_item heading"><span>Knowledge</span></div>
							<div class="sga-items_item flexed" v-for="(upskill, index) in this.$props.info.fullSGA.sgaUpSkills.knowledgeRegularlyUsed" :key="index" style="word-break: break-word;">
								<img src="../assets/img/upskill3.svg">
								<div class="right">
									<span>{{ upskill.Selection }}</span>
								</div>
							</div>
						</div>
						<div class="sga-items" v-if="this.$props.Info.fullSGA.sgaUpSkills.workingPracticeSkills">
							<div class="sga-items_item heading"><span>Skills</span></div>
							<div class="sga-items_item flexed" v-for="(upskill, index) in this.$props.Info.fullSGA.sgaUpSkills.workingPracticeSkills" :key="index" style="word-break: break-word;">
								<img src="../assets/img/upskill3.svg">
								<div class="right">
									<span>{{ upskill.selection }}</span>
								</div>
							</div>
						</div>
					</div>
        </el-tab-pane>

        <el-tab-pane label="Tasks" name="tasks">
          <span class="h6">Tasks </span>
					<div class="sga-items" v-if="this.$props.Info && this.$props.Info.fullSGA && this.$props.Info.fullSGA.sgaYourJob">
						<div class="sga-items_item flexed" v-for="(task, index) in this.$props.Info.fullSGA.sgaYourJob.jobDescriptionTasks" :key="index" style="word-break: break-word;">
              <div v-if="task.indexOf('`') > -1">
                <div v-if="code !== 'Others'">
                  <span> {{ task.split("`")[0] }} </span>
                </div>
              </div>
              <div v-if="code == 'Others'">
                <div v-if="task.indexOf('`') == -1">
                  <span class="class_Others">{{ task }}</span>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Activities" name="activities">
          <span class="h6">Activities</span>
					<div class="sga-items" v-if="this.$props.Info && this.$props.Info.fullSGA && this.$props.Info.fullSGA.sgaHiddenExtras">
						<div class="sga-items_item flexed" v-for="(activity, index) in this.$props.Info.fullSGA.sgaHiddenExtras.workingPracticeActivities" :key="index">
              <span>{{ activity.selection }}</span>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Education" name="education">
          <span class="h6">Education</span>
          <div v-if="this.$props.Info.fullSGA.sgaEducation" class="sga-split" style="height: 400px !important;">
            <div class="sga-items no_border">
              <div v-if="this.$props.Info.fullSGA.sgaEducation.secondLevelEducation">
                <div class="sga-items_item heading">
                  <strong>Second Level Education</strong>
                </div>
                <div class="with_border" v-if="this.$props.Info.fullSGA.sgaEducation.secondLevelEducation.highSchoolDiploma">
                  <span>High School Diploma</span>
                  <div class="sga-items_item no_border">
                    <span>High School Diploma</span>
                    <span v-if="this.$props.Info.fullSGA.sgaEducation.secondLevelEducation.highSchoolDiplomaAttending">
                      Graduation Date : {{this.$props.Info.fullSGA.sgaEducation.secondLevelEducation.highSchoolDiplomaGraduationDate | moment("MMMM DD, YYYY")}}
                    </span>
                  </div>
                </div>
                <div class="with_border" v-if="this.$props.Info.fullSGA.sgaEducation.secondLevelEducation.ged">
                  <span>GED</span>
                  <div class="sga-items_item no_border">
                    <span>GED</span>
                    <span v-if="this.$props.Info.fullSGA.sgaEducation.secondLevelEducation.gedAttending">
                      Graduation Date : {{this.$props.Info.fullSGA.sgaEducation.secondLevelEducation.gedGraduationDate | moment("MMMM DD, YYYY")}}
                    </span>
                  </div>
                </div>
                <div class="with_border" v-if="this.$props.Info.fullSGA.sgaEducation.secondLevelEducation.aLevels">
                  <span>A Levels</span>
                  <div class="sga-items_item no_border" v-for="(a_level, index) in this.$props.Info.fullSGA.sgaEducation.secondLevelEducation.aLevelDetails" :key="index">
                    <span>{{ a_level.grade }} - {{ a_level.subject }}</span>
                  </div>
                </div>
                <div class="with_border" v-if="this.$props.Info.fullSGA.sgaEducation.secondLevelEducation.leavingCert">
                  <span>Leaving Cert</span>
                  <div class="sga-items_item no_border">
                    <span>Leaving Cert</span>
                  </div>
                </div>
                <div class="with_border" v-if="this.$props.Info.fullSGA.sgaEducation.secondLevelEducation.oLevels">
                  <span>O Levels</span>
                  <div class="sga-items_item no_border" v-for="(o_level, index) in this.$props.Info.fullSGA.sgaEducation.secondLevelEducation.oLevelDetails" :key="index">
                    <span>{{ o_level.grade }} - {{ o_level.subject }}</span>
                  </div>
                </div>
              </div>
              
              <div v-if="this.$props.Info.fullSGA.sgaEducation.fourthLevelEducation">
                <div class="sga-items_item heading">
                  <strong>Fourth Level Education</strong>
                </div>
                <div class="with_border" v-if="this.$props.Info.fullSGA.sgaEducation.fourthLevelEducation.mastersDegree">
                  <span>Masters Degree</span>
                  <div class="sga-items_item no_border" v-for="(ma_degree, index) in this.$props.Info.fullSGA.sgaEducation.fourthLevelEducation.mastersDegreeDetails" :key="index">
                    <span>{{ ma_degree.courseTitle }}</span>
                    <span style="word-break: break-word" v-if="ma_degree.currentlyAttending">
                      - Graduation Date : {{ ma_degree.graduationDate | moment("MMMM DD, YYYY") }}
                    </span>
                  </div>
                </div>
                <div class="with_border" v-if="this.$props.Info.fullSGA.sgaEducation.fourthLevelEducation.doctoralDegree">
                  <span>Masters Degree</span>
                  <div class="sga-items_item no_border" v-for="(phd_degree, index) in this.$props.Info.fullSGA.sgaEducation.fourthLevelEducation.doctoralDegreeDetails" :key="index">
                    <span>{{ phd_degree.courseTitle }}</span>
                    <span style="word-break: break-word" v-if="phd_degree.currentlyAttending">
                      - Graduation Date :{{ phd_degree.graduationDate | moment("MMMM DD, YYYY") }}
                    </span>
                  </div>
                </div>
              </div>
              
            </div>
            <div class="sga-items">
              <div v-if="this.$props.Info.fullSGA.sgaEducation.thirdLevelEducation">
                <div class="sga-items_item heading">
                  <strong>Third Level Education</strong>
                </div>
                <div class="with_border" v-if="this.$props.Info.fullSGA.sgaEducation.thirdLevelEducation.associateDegree">
                  <span>Associate Degree</span>
                  <div class="sga-items_item no_border" v-for="(assoc_degree, index) in this.$props.Info.fullSGA.sgaEducation.thirdLevelEducation.associateDegreeDetails" :key="index">
                    <span>{{ assoc_degree.courseTitle }}</span>
                    <span style="word-break: break-word" v-if="assoc_degree.currentlyAttending">
                      - Graduation Date :{{assoc_degree.graduationDate | moment("MMMM DD, YYYY")}}
                    </span>
                  </div>
                </div>
                <div class="with_border" v-if="this.$props.Info.fullSGA.sgaEducation.thirdLevelEducation.bachelorsDegree">
                  <span>Bachelors Degree</span>
                  <div class="sga-items_item no_border" v-for="(bs_degree, index) in this.$props.Info.fullSGA.sgaEducation.thirdLevelEducation.bachelorsDegreeDetails" :key="index">
                    <span>{{ bs_degree.courseTitle }}</span>
                    <span style="word-break: break-word" v-if="bs_degree.currentlyAttending">
                      - Graduation Date :{{ bs_degree.graduationDate | moment("MMMM DD, YYYY") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label = "Certifications" name="certifications">
          <span class="h6">Certifications</span>
            <div class="sga-items">
              <div class="sga-items_item" v-for="(cert, index) in this.$props.Info.fullSGA.sgaCertifications.userCertifications" :key="index">
                <div v-if="cert.codeDetailDesc == null">
                  <span>N/A</span>
                </div>
                <div v-else>                  
                  {{ cert.codeDetailDesc }}
                </div>
              </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Knowledge" name="knowledge">
          <span class="h6">Knowledge</span>
          <div class="sga-split">
						<div class="sga-items" v-if="this.$props.Info && this.$props.Info.fullSGA && this.$props.Info.fullSGA.sgaKnowledge">
							<div class="sga-items_item heading"><span>Expected by employer</span></div>
              
              <div class="sga-items_item" v-for="(knowledge, index) in this.$props.Info.fullSGA.sgaKnowledge.knowledgeRegularlyUsed" v-if="knowledge.value == 'IN'" :key="index">
								<!-- <img src="~../../../assets/img/inwork.svg" alt="Inside role" /> -->
								<span>{{ knowledge.selection }}</span>
								<span>{{ knowledge.yearsOfExperience }} years experience</span>
							</div>
						</div>
						<div class="sga-items" v-if="this.$props.Info && this.$props.Info.fullSGA && this.$props.Info.fullSGA.sgaKnowledge">
							<div class="sga-items_item heading"><span>{{ this.$props.TypeLabel }} adds to role</span></div>

              <div class="sga-items_item" v-for="(knowledge, index) in this.$props.Info.fullSGA.sgaKnowledge.knowledgeRegularlyUsed" v-if="knowledge.value == 'OUT'" :key="index">
								<!-- <img src="~../../../assets/img/outwork.svg" alt="Outside of role" /> -->
                <span>{{ knowledge.selection }}</span>
								<span>{{ knowledge.yearsOfExperience }} years experience</span>
							</div>
						</div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Skills" name="skills">
          <span class="h6">Skills</span>
					<div class="sga-split">
						<div class="sga-items" v-if="this.$props.Info && this.$props.Info.fullSGA && this.$props.Info.fullSGA.sgaSkills">
							<div class="sga-items_item heading"><span>Expected by employer</span></div>
							<div class="sga-items_item" v-for="(skill, index) in this.$props.Info.fullSGA.sgaSkills.workingPracticeSkills" :key="index" v-if="skill.value == 'IN'">
                <!-- <img src="~../../../assets/img/inwork.svg" alt="Outside of role" /> -->
								<span>{{ skill.selection }}</span>
								<span>{{ skill.yearsOfExperience }} years experience</span>
							</div>
						</div>
						<div class="sga-items" v-if="this.$props.Info && this.$props.Info.fullSGA && this.$props.Info.fullSGA.sgaSkills">
							<div class="sga-items_item heading"><span>{{ this.$props.TypeLabel }} adds to role</span></div>
							<div class="sga-items_item" v-for="(skill, index) in this.$props.Info.fullSGA.sgaSkills.workingPracticeSkills" :key="index" v-if="skill.value == 'OUT'">
                <!-- <img src="~../../../assets/img/outwork.svg" alt="Outside of role" /> -->
								<span>{{ skill.selection }}</span>
								<span>{{ skill.yearsOfExperience }} years experience</span>
							</div>
						</div>
					</div>
        </el-tab-pane>

        <el-tab-pane label="Essential Skills" name="mindsets">
         <span class="h6">Essential Skills</span>
					<div class="sga-split">
						<div class="sga-items" v-if="this.$props.Info && this.$props.Info.fullSGA && this.$props.Info.fullSGA.sgaMindset">
							<div class="sga-items_item heading"><span>Expected by employer</span></div>
							<div class="sga-items_item" v-for="(mindset, index) in this.$props.Info.fullSGA.sgaMindset.mindsets" :key="index" v-if="mindset.value == 'IN'">
                <!-- <img src="~../../../assets/img/inwork.svg" alt="Outside of role" /> -->
								<span>{{ mindset.selection }}</span>
							</div>
						</div>
						<div class="sga-items" v-if="this.$props.Info && this.$props.Info.fullSGA && this.$props.Info.fullSGA.sgaMindset">
							<div class="sga-items_item heading"><span>{{ this.$props.TypeLabel }} adds to role</span></div>
							<div class="sga-items_item" v-for="(mindset, index) in this.$props.Info.fullSGA.sgaMindset.mindsets" :key="index" v-if="mindset.value == 'OUT'">
                <!-- <img src="~../../../assets/img/outwork.svg" alt="Outside of role" /> -->
								<span>{{ mindset.selection }}</span>
							</div>
						</div>
					</div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <span slot="footer" class="ts-modal--footer">
      <el-button type="primary" @click="closeModal()">Close</el-button>
    </span>

    <el-dialog
      title="Decline Invitation"
      :visible="showDeclineConnectModal"
      :append-to-body="true"
      :show-close="false"
      width="600px"
      class="ts-modal"
    >
      <p>
        Are you sure you want to cancel the process you have started with company <u>{{ this.$props.Info.companyName }}</u>
        regarding the role matching for <u>{{ this.$props.Info.roleTitle }}</u>?
      </p>
      <p>
        This will cancel the process between you and the employer. <br />
        Your contact and other details will become anoynmous again after the
        cancellation.
      </p>
      &nbsp;&nbsp;
      <el-row>
        <el-col :offset="7" :xl="6" :lg="6" :md="6">
          <button
            style="width: 100px"
            class="ts-btn ts-btn-small"
            @click="declineConnect"
          >
            Yes
          </button>
        </el-col>
        <el-col :xl="6" :lg="6" :md="6">
          <button
            style="width: 100px"
            class="ts-btn ts-btn-small ts-btn-white"
            @click="onCloseDeclineConnectDialog()"
          >
            No
          </button>
        </el-col>
      </el-row>
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  name: "RoleInfo",
  props: {
    Info: {
      type: Object,
      default() {
        return {};
      },
    },
    ShowModal: {
      type: Boolean,
      default: false,
    },
    TypeLabel: {
      type: String,
      Default: "Apprentice",
    },
  },
  data() {
    return {
      activeTab: "tasks",
      showDeclineConnectModal: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("role-info-closed");
    },
    cancelJobMatch() {
      this.showDeclineConnectModal = true;
    },
    declineConnect() {
      this.$store
        .dispatch(
          "apprentice/declineCompanyInvitationToConnect",
          this.$props.Info
        )
        .then((res) => {
          this.$emit("cancel-job-match-success", res);
          this.onCloseDeclineConnectDialog();
        })
        .catch((res) => {
          this.$message.error(res.error);
        });
    },
    onCloseDeclineConnectDialog() {
      this.showDeclineConnectModal = false;
    },
  },
};
</script>
